import { ReactComponent as InfoIcon } from "@assets/icons/info_bolded.svg"
import { ReactComponent as LockIcon } from "@assets/icons/lock.svg"
import { ReactComponent as PhoneReceive } from "@assets/icons/phone_receive.svg"
import type React from "react"
import { memo } from "react"

type CardInformationProps = {
  variant: "safe" | "info" | "phone_receive"
  description: string | React.ReactElement
  showMoreToggle?: boolean
  showMoreContent?: string | React.ReactElement
}

const CardInformation: React.FC<CardInformationProps> = ({ variant, description, showMoreToggle, showMoreContent }) => {
  const variants = {
    safe: <LockIcon />,
    info: <InfoIcon />,
    phone_receive: <PhoneReceive />,
  }

  return (
    <div className="bg-pn_paper-3 rounded-2xl border border-pn_gray-200">
      <div className="flex items-center gap-x-[17px] p-4">
        <div className="rounded-full p-2 bg-[#F4E34E] flex items-center justify-center">{variants[variant]}</div>
        <div className="text-pn-callout-regular">{description}</div>
      </div>

      {showMoreContent && showMoreToggle && (
        <div className="px-4">
          <div className="divider-dotted-gray"></div>
        </div>
      )}

      {showMoreContent && showMoreToggle && showMoreContent}
    </div>
  )
}
export default memo(CardInformation)
